import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si soy AT sin formación formal en ABA?',
    a: 'El MegaPack está diseñado para ser comprendido y aplicado por cualquier profesional que trabaje con niños con TEA o desafíos del neurodesarrollo, independientemente del nivel de formación. Los protocolos están explicados en lenguaje claro, con ejemplos específicos del contexto argentino. Muchos de nuestros compradores son ATs que empezaron sin base técnica y hoy trabajan con sistema.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Tras el pago confirmado, recibís un email con los links de descarga en menos de 5 minutos. Todo en PDF, descargable de por vida, accesible desde celular, tablet o computadora. También podés imprimirlos si preferís trabajar en papel.'
  }, {
    q: '¿Está adaptado al contexto argentino?',
    a: '100%. El material menciona Obras Sociales argentinas (OSDE, IOMA, PAMI, Galeno, Swiss Medical, entre otras), el sistema de CUD, el marco legal de la Ley 24.901, el sistema educativo argentino con PPI y maestros integradores, y el contexto real del trabajo en consultorio, domicilio y escuela en Argentina.'
  }, {
    q: '¿Necesito conocimiento previo en ABA?',
    a: 'No. El Tomo 1 empieza desde los fundamentos del análisis conductual aplicado y va construyendo progresivamente. Si ya tenés formación, vas a encontrar el material que siempre necesitaste tener organizado y listo para usar.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días desde la compra, devolución completa sin ningún requisito adicional. Escribís a packcentral23@gmail.com y procesamos el reembolso en 48 horas. Sin preguntas.'
  }, {
    q: '¿Sirve también para trabajar con padres y familias?',
    a: 'Absolutamente. El material incluye guías específicas para el entrenamiento familiar, scripts de comunicación, contratos de colaboración y estrategias para que los padres puedan implementar en casa lo que se trabaja en sesión. Muchas familias compran el MegaPack directamente para acompañar mejor a sus hijos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-cyan-950" data-id="element-76">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-77">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-78">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-79">
          {faqs.map((faq, i) => <div key={i} className="border border-cyan-800 rounded-2xl overflow-hidden bg-cyan-900/60" data-id="element-80">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400 hover:bg-cyan-900/40 transition-colors" aria-expanded={openIndex === i} data-id="element-81">
                <span className="font-bold text-white pr-4" data-id="element-82">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-cyan-300 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-83" />
              </button>

              <AnimatePresence data-id="element-84">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-85">
                    <div className="px-6 pb-5 text-cyan-100 leading-relaxed border-t border-cyan-800 pt-3" data-id="element-86">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}